import React, { PureComponent } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { I, L } from '../common/v5/config';
import { CONTACTS_TOPLIST_STR, CL_OVERVIEW } from '../common/v5/constants';
import { getChevronIcon } from '../common/v5/helpers';
import { composeWithDisplayName, withPointerClickableOnClick } from './hocs';
import { withMeasurableHeight } from '../styles/autoHeight';
import { ChartTitle, ChartLink, withLinkClickHandle } from './ChartTitleLink';

const Img = ({col, row}) => (
	<div>
		<span></span>
		<img className="leaderboard-avatar" src={row.img} />
		<span></span>
	</div>
);

const Title = props => <ChartTitle text={L(CONTACTS_TOPLIST_STR)} {...props} />;

const FooterLink = props => <ChartLink className="leaderboard-footer" title={L(CONTACTS_TOPLIST_STR)} {...props} />;

const ClickableDiv = withPointerClickableOnClick("div");

const Table = ({ onClick, unclickable, ...props }) => (
	<ClickableDiv onClick={onClick} unclickable={unclickable}>
		<BootstrapTable {...props} />
	</ClickableDiv>
);

const sortDesc = "desc"
	, sortAsc = "asc"
	;
const withContactsTopList = Component => class extends PureComponent {
	constructor(props) {
		super(props);
		this.getCaret = this.getCaret.bind(this);
		this.handleTableClick = this.handleTableClick.bind(this);
		this.state = {
			sortDir: sortDesc
		};
		this.options = {
			onSortChange: this.onSortChange.bind(this),
			defaultSortOrder: sortDesc,
			defaultSortName: "errands"
		};
	};
	imgFormatter(col, row) {
		return <Img col={col} row={row} />
	};
	getCaret(dir) {
		let down;
		if (dir === sortDesc) {
			down = true;
		}
		return <span><i className={getChevronIcon(!down)} /></span>;
	};
	handleTableClick(e) {
		if (this.isOnSortChangeClick) {
			this.isOnSortChangeClick = false;
		} else {
			this.props.onLinkClick(e);
		}
	};
	onSortChange(sortName, sortOrder) {
		this.isOnSortChangeClick = true;
		this.setState({sortDir: sortOrder});
	}
	indexNumberAsc(cell, row, extra, index) {
		return (<div>{index+1}</div>)
	}
	indexNumberDesc(cell, row, extra, index) {
		let indexRowDesc = extra - index
		return (<div>{indexRowDesc}</div>)
	}
	render() {
		const {
				hideTitleAndLink
				, measureRef
				, onLinkClick
				, square
				, style
				, layout
			} = this.props
			;
		let data = []
			, dataLength = 0
			, hideColumnIndex = (this.state.sortDir === sortAsc) ? true : false
			;
		if(this.props.data) {
			dataLength = this.props.data.length;
			data = this.props.data;
		};
		return (
			<Component
				className="c3-leaderboard-table"
				ref={measureRef}
				style={style}
			>
				<Title hidden={layout === CL_OVERVIEW ? false : true} />
				<div className="no-footer">
					{/* TODO: convert it react-table because BootstrapTable */}
					{/* can't support default multi-sort. */}
					<Table
						data={data}
						hover
						onClick={this.handleTableClick}
						options={this.options}
						printable
						tableBodyClass='wf-body-class'
						unclickable={hideTitleAndLink}
					>
						<TableHeaderColumn dataField='id' isKey width='10%' hidden />
						<TableHeaderColumn
							className="rank"
							dataField={sortAsc}
							dataFormat={this.indexNumberAsc}
							hidden={hideColumnIndex}
							width='10%'
						>
							{I("Rank ")}<i className="fas fa-medal"></i>
						</TableHeaderColumn>
						<TableHeaderColumn
							className="rank"
							dataField={sortDesc}
							dataFormat={this.indexNumberDesc}
							formatExtraData={dataLength}
							hidden={!hideColumnIndex}
							width='10%'
						>
							{I("Rank ")}<i className="fas fa-medal"></i>
						</TableHeaderColumn>
						<TableHeaderColumn dataField='img' dataFormat={this.imgFormatter} width='10%' />
						<TableHeaderColumn dataField='name' width='30%' />
						<TableHeaderColumn
							dataField={"errands"}
							dataSort
							caretRender={this.getCaret}
							width='25%'
							hidden={false}
						>
							<span className="active">
								{I("Errands")}
							</span>
						</TableHeaderColumn>
					</Table>
					<FooterLink
						hidden={hideTitleAndLink}
						onClick={onLinkClick}
					/>
				</div>
			</Component>
		);
	}
};

const ContactsToplist = composeWithDisplayName(
	"ContactsToplist"
	, withLinkClickHandle
	, withMeasurableHeight
	, withContactsTopList
)("div");

export default ContactsToplist;
